module.exports = __webpack_public_path__ + "img/home-fhc1.577268d9.png";